import api from './api';

export const contractFinanceService = {
  getContractPayments: async (contractId, params = {}) => {
    try {
      const response = await api.get('/finance/contracts/payments', { params: { ...params, contractId } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createContractPayment: async (contractId, data) => {
    try {
      const response = await api.post('/finance/contracts/payments', { ...data, contractId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getContractPayment: async (paymentId) => {
    try {
      const response = await api.get(`/finance/contracts/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateContractPayment: async (paymentId, data) => {
    try {
      const response = await api.put(`/finance/contracts/payments/${paymentId}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteContractPayment: async (paymentId) => {
    try {
      const response = await api.delete(`/finance/contracts/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getContractInvoices: async (contractId) => {
    try {
      const response = await api.get('/finance/contracts/invoices', { params: { contractId } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  generateInvoice: async (contractId, data) => {
    try {
      const response = await api.post('/finance/contracts/invoices', { ...data, contractId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getRevenueRecognition: async (contractId) => {
    try {
      const response = await api.get(`/finance/contracts/${contractId}/revenue-recognition`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getAnalytics: async () => {
    try {
      const response = await api.get('/finance/contracts/analytics');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};
